import { Suspense } from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import DefaultLoader from "./components/loaders/default-loader";
import { UserProvider } from "./contexts/UserContext";
import { FiltersProvider } from "./contexts/FiltersContext";
import { Navigation } from "./components/navigations";

function App() {
  return (
    <HelmetProvider>
      <UserProvider>
        <FiltersProvider>
          <Suspense fallback={<DefaultLoader />}>
            <Navigation />
          </Suspense>
        </FiltersProvider>
      </UserProvider>
    </HelmetProvider>
  );
}

export default App;
